var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-group"},[_c('check-list',{attrs:{"label":"Subjectivities?","item-value":"name","item-rules":[
            _vm.ruleRequired,
            v => Boolean(v.replace(/ /g, '')) || 'Required',
            v => Boolean(v.length <= 255) || 'Subjectivities must be less than 255 characters'
        ],"item-hide-details":"","addition-text":"Add subjectivity"},model:{value:(_vm.subjectivityTypes),callback:function ($$v) {_vm.subjectivityTypes=$$v},expression:"subjectivityTypes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }